<div class="flex-between align-items-center gap-3 w-100 mb-1">
    <label class="fieldKey text-muted m-0" (click)="makeNameEditable()">
        <span *ngIf="!editName">{{ customField.fieldName }}</span>
        <span *ngIf="!!editName"><input [attr.id]="'fieldName' + customField.id" [(ngModel)]="customField.fieldName" type="text" class="form-control form-control-sm" (blur)="updateCustomField(); editName = false"></span>
    </label>
    <!-- Decimal -->
    <div class="fieldValue" *ngIf="customField.typeId == 'f7bcf698-b090-44c3-a9a8-10fde72e7282'" [ngClass]="!!editable ? 'w-100' : 'form-control-custom'">
        <input type="number" [(ngModel)]="value" class="form-control borderless w-100" (change)="changeValue()">
    </div>
    <!-- Choice -->
    <div class="d-flex align-items-center position-relative fieldValue" *ngIf="customField.typeId == '27e3ae4d-3a11-44be-884b-1e264176049e'">
        <input type="text" class="form-control borderless w-100" [(ngModel)]="value" (focus)="openOptionsList($event)" (click)="openOptionsList($event)" (blur)="click()" placeholder="{{ 'Standard.NoneChosen' | translate }}">
        <button class="btn btn-sm btn-secondary ml-3" data-toggle="modal" [attr.data-target]="'#optionsToCustomField' + customField.id" data-target="#optionsToCustomField" (click)="choicesToText()" *ngIf="!!editable">{{ 'Buttons.AddOptions' | translate }}</button>
        <div [attr.id]="'customFieldsOptionsList' + customField.id" class="optionsList position-absolute">
            <div *ngFor="let x of customField.template" (click)="value = x; changeValue()">{{ x }}</div>
        </div>
    </div>
    <!-- Text -->
    <div class="fieldValue" *ngIf="customField.typeId == 'ff07e38b-1905-479f-836f-1e648bc14e54'">
        <input type="text" [(ngModel)]="value" class="form-control borderless" (change)="changeValue()">
    </div>
    <!-- MultiLine -->
    <div class="fieldValue" *ngIf="customField.typeId == '71b6ab58-9d86-4b85-99eb-26a5db0cbbb2'">
        <textarea rows="2" class="form-control borderless" [(ngModel)]="value" (focus)="autoGrow($event)" (keyup)="autoGrow($event)" (blur)="autoShrink($event)" (change)="changeValue()"></textarea>
    </div>
    <!-- Datetime -->
    <div class="fieldValue" *ngIf="customField.typeId == '515e2ba9-bb53-4860-966d-669c4af1fa7c'">
        <input type="datetime-local" class="form-control borderless" [(ngModel)]="value" (change)="changeValue()">
    </div>
    <!-- Date -->
    <div class="fieldValue" *ngIf="customField.typeId == 'ffbfd192-be48-4306-8a00-743a56708167'">
        <input type="date" class="form-control borderless" [(ngModel)]="value" (change)="changeValue()">
    </div>
    <!-- Yes/No -->
    <div class="fieldValue pl-3" *ngIf="customField.typeId == 'f21df8df-a7eb-43b9-a25b-99704d70c96c'">
        <label class="switch" [title]=" !!value ? (( 'Buttons.Yes' | translate ) | lowercase) : (( 'Buttons.No' | translate) | lowercase)">
            <input type="checkbox" [checked]="value == 'true'" (change)="changeValue($event);">
            <span class="slider rounded"></span>
          </label>
    </div>
</div>

<div [attr.id]="'optionsToCustomField' + customField.id " class="modal fade">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5>{{ 'Buttons.AddOptions' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
            </div>
            <div class="modal-body flex-between align-items-start">
                <textarea class="form-control" rows="10" [(ngModel)]="editChoice" (click)="textareaClick($event)"></textarea>
                <div class="d-flex flex-column ml-3">
                    <button class="btn btn-sm btn-primary" (click)="sortEditChoice()">{{ 'Forms.SortListOnConvert' | translate }}</button>
                    <button class="btn btn-sm btn-primary" (click)="textToCase('upper')">{{ ('Word.Text' | translate) | uppercase }}</button>
                    <button class="btn btn-sm btn-primary" (click)="textToCase('title')">{{ ('Word.Text' | translate) | titlecase }}</button>
                    <button class="btn btn-sm btn-primary" (click)="textToCase('lower')">{{ ('Word.Text' | translate) | lowercase }}</button>
                </div>
            </div>
            <div class="modal-footer flex-between">
                <button class="btn btn-sm btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
                <button class="btn btn-sm btn-primary" data-dismiss="modal" (click)="textToChoices()">{{ 'Buttons.Save' | translate }}</button>
            </div>
        </div>
    </div>
</div>
